function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function samePagination(oldPag, newPag) {
  for (var prop in newPag) {
    if (newPag[prop] !== oldPag[prop]) {
      return false;
    }
  }

  return true;
}

function fixPagination(p) {
  if (p.page < 1) {
    p.page = 1;
  }

  if (p.rowsPerPage !== void 0 && p.rowsPerPage < 1) {
    p.rowsPerPage = 0;
  }

  return p;
}

export default {
  props: {
    pagination: Object,
    rowsPerPageOptions: {
      type: Array,
      "default": function _default() {
        return [5, 7, 10, 15, 20, 25, 50, 0];
      }
    }
  },
  computed: {
    computedPagination: function computedPagination() {
      var pag = this.qListeners['update:pagination'] !== void 0 ? _objectSpread(_objectSpread({}, this.innerPagination), this.pagination) : this.innerPagination;
      return fixPagination(pag);
    },
    firstRowIndex: function firstRowIndex() {
      var _this$computedPaginat = this.computedPagination,
          page = _this$computedPaginat.page,
          rowsPerPage = _this$computedPaginat.rowsPerPage;
      return (page - 1) * rowsPerPage;
    },
    lastRowIndex: function lastRowIndex() {
      var _this$computedPaginat2 = this.computedPagination,
          page = _this$computedPaginat2.page,
          rowsPerPage = _this$computedPaginat2.rowsPerPage;
      return page * rowsPerPage;
    },
    isFirstPage: function isFirstPage() {
      return this.computedPagination.page === 1;
    },
    pagesNumber: function pagesNumber() {
      return this.computedPagination.rowsPerPage === 0 ? 1 : Math.max(1, Math.ceil(this.computedRowsNumber / this.computedPagination.rowsPerPage));
    },
    isLastPage: function isLastPage() {
      return this.lastRowIndex === 0 ? true : this.computedPagination.page >= this.pagesNumber;
    },
    computedRowsPerPageOptions: function computedRowsPerPageOptions() {
      var _this = this;

      var opts = this.rowsPerPageOptions.includes(this.innerPagination.rowsPerPage) ? this.rowsPerPageOptions : [this.innerPagination.rowsPerPage].concat(this.rowsPerPageOptions);
      return opts.map(function (count) {
        return {
          label: count === 0 ? _this.$q.lang.table.allRows : '' + count,
          value: count
        };
      });
    }
  },
  watch: {
    pagesNumber: function pagesNumber(lastPage, oldLastPage) {
      if (lastPage === oldLastPage) {
        return;
      }

      var currentPage = this.computedPagination.page;

      if (lastPage && !currentPage) {
        this.setPagination({
          page: 1
        });
      } else if (lastPage < currentPage) {
        this.setPagination({
          page: lastPage
        });
      }
    }
  },
  methods: {
    __sendServerRequest: function __sendServerRequest(pagination) {
      this.requestServerInteraction({
        pagination: pagination,
        filter: this.filter
      });
    },
    setPagination: function setPagination(val, forceServerRequest) {
      var newPagination = fixPagination(_objectSpread(_objectSpread({}, this.computedPagination), val));

      if (samePagination(this.computedPagination, newPagination)) {
        if (this.isServerSide === true && forceServerRequest === true) {
          this.__sendServerRequest(newPagination);
        }

        return;
      }

      if (this.isServerSide === true) {
        this.__sendServerRequest(newPagination);

        return;
      }

      if (this.pagination !== void 0 && this.qListeners['update:pagination'] !== void 0) {
        this.$emit('update:pagination', newPagination);
      } else {
        this.innerPagination = newPagination;
      }
    },
    firstPage: function firstPage() {
      this.setPagination({
        page: 1
      });
    },
    prevPage: function prevPage() {
      var page = this.computedPagination.page;

      if (page > 1) {
        this.setPagination({
          page: page - 1
        });
      }
    },
    nextPage: function nextPage() {
      var _this$computedPaginat3 = this.computedPagination,
          page = _this$computedPaginat3.page,
          rowsPerPage = _this$computedPaginat3.rowsPerPage;

      if (this.lastRowIndex > 0 && page * rowsPerPage < this.computedRowsNumber) {
        this.setPagination({
          page: page + 1
        });
      }
    },
    lastPage: function lastPage() {
      this.setPagination({
        page: this.pagesNumber
      });
    }
  },
  created: function created() {
    if (this.qListeners['update:pagination'] !== void 0) {
      this.$emit('update:pagination', _objectSpread({}, this.computedPagination));
    }
  }
};